import script from "./ServiceProcess.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceProcess.vue?vue&type=script&setup=true&lang=js"

import "./ServiceProcess.vue?vue&type=style&index=0&id=236c71c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-236c71c0"]])

export default __exports__